import { render } from "./AddressSelection.vue?vue&type=template&id=8b2ae0ba"
import script from "./AddressSelection.vue?vue&type=script&lang=js"
export * from "./AddressSelection.vue?vue&type=script&lang=js"
script.render = render

export default script